import { CustomerOptions } from '../../mdqx-graphql-types';
import {
    SelectSearchOption
} from '../../../dave-utils-module/select-search/components/select-search/select-search.component';

export enum federalState {
    BADEN_WUERTTEMBERG = 'BADEN_WUERTTEMBERG',
    BAYERN = 'BAYERN',
    BERLIN = 'BERLIN',
    BRANDENBURG = 'BRANDENBURG',
    BREMEN = 'BREMEN',
    HAMBURG = 'HAMBURG',
    HESSEN = 'HESSEN',
    MECKLENBURG_VORPOMMERN = 'MECKLENBURG_VORPOMMERN',
    NIEDERSACHSEN = 'NIEDERSACHSEN',
    NORDRHEIN_WESTFALEN = 'NORDRHEIN_WESTFALEN',
    RHEINLAND_PFALZ = 'RHEINLAND_PFALZ',
    SAARLAND = 'SAARLAND',
    SACHSEN = 'SACHSEN',
    SACHSEN_ANHALT = 'SACHSEN_ANHALT',
    SCHLESWIG_HOLSTEIN = 'SCHLESWIG_HOLSTEIN',
    THUERINGEN = 'THUERINGEN',
}

export const getFederalStateName = (fs: federalState) => {
    switch (fs) {
        case federalState.BADEN_WUERTTEMBERG:
            return "Baden-Württemberg";
        case federalState.BAYERN:
            return "Bayern";
        case federalState.BERLIN:
            return "Berlin";
        case federalState.BRANDENBURG:
            return "Brandenburg";
        case federalState.BREMEN:
            return "Bremen";
        case federalState.HAMBURG:
            return "Hamburg";
        case federalState.HESSEN:
            return "Hessen";
        case federalState.MECKLENBURG_VORPOMMERN:
            return "Mecklenburg-Vorpommern";
        case federalState.NIEDERSACHSEN:
            return "Niedersachsen";
        case federalState.NORDRHEIN_WESTFALEN:
            return "Nordrhein-Westfalen";
        case federalState.RHEINLAND_PFALZ:
            return "Rheinland-Pfalz";
        case federalState.SAARLAND:
            return "Saarland";
        case federalState.SACHSEN:
            return "Sachsen";
        case federalState.SACHSEN_ANHALT:
            return "Sachsen-Anhalt";
        case federalState.SCHLESWIG_HOLSTEIN:
            return "Schleswig-Holstein";
        case federalState.THUERINGEN:
            return "Thüringen";
            default:
                return "";
    }
}
export const federalStateOptions: SelectSearchOption< {value: federalState }>[] = Object.keys(federalState).map(key => ({
    value: federalState[key],
    optionLabel: getFederalStateName(federalState[key]),
}))
export class CustomerOptionsEntity {
    public static readonly GqlFields = 'id customerId practiceTypeId federalState paymentTarget ik bsnr';

    public BSNR?: string | null;
    public CustomerId: number;
    public FederalState?: federalState | null;
    public Id: number;
    public IK?: string | null;
    public PaymentTarget?: string | null;
    public PracticeTypeId?: number | null;

    constructor(customerOptionsType?: CustomerOptions | null) {
        if (
            customerOptionsType &&
            customerOptionsType.bsnr !== undefined &&
            customerOptionsType.customerId != null &&
            // (customerOptionsType.federalState === null || Object.values(federalState).includes(customerOptionsType.federalState as federalState)) && todo einkommentieren
            customerOptionsType.id != null &&
            customerOptionsType.ik !== undefined &&
            customerOptionsType.paymentTarget !== undefined &&
            customerOptionsType.practiceTypeId !== undefined
        ) {
            this.BSNR = customerOptionsType.bsnr;
            this.CustomerId = customerOptionsType.customerId;
            this.FederalState = customerOptionsType.federalState as federalState;
            this.IK = customerOptionsType.ik;
            this.Id = customerOptionsType.id;
            this.PaymentTarget = customerOptionsType.paymentTarget;
            this.PracticeTypeId = customerOptionsType.practiceTypeId;
        } else {
            console.error('Received broken CustomerOptionsType', customerOptionsType);
            throw Error();
        }
    }
}
